import { useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

const useRouteCompleteDataSelector = ({ selectorFnGen, refDefault }) => {
  const { route } = useRouter();
  const dataRef = useRef(refDefault);
  const data = useSelector(selectorFnGen({ ref: dataRef, route }));
  useEffect(() => {
    // storing current page's layoutOptions on route change complete
    dataRef.current = data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route]);
  return data;
};

const emptyObject = {};

export const useLayoutOptionsSelector = () => {
  // we are dng this bcoz layout options change even before route changes
  // so we have to wait until route change
  // till then, we have to pass previous page's layout options
  const selectorFnGen = ({ ref, route }) => ({ currentPageInfo }) =>
    (currentPageInfo.route === route
      ? currentPageInfo.layoutOptions
      : ref.current) || emptyObject;
  return useRouteCompleteDataSelector({
    selectorFnGen,
    refDefault: emptyObject
  });
};

export const useFlagSelector = (flag) => {
  // we are dng this bcoz layout options change even before route changes
  // so we have to wait until route change
  // till then, we have to pass previous page's layout options
  const selectorFnGen = ({ ref, route }) => ({ currentPageInfo }) =>
    currentPageInfo.route === route
      ? currentPageInfo.layoutOptions[flag] || false
      : ref.current;
  return useRouteCompleteDataSelector({ selectorFnGen, refDefault: false });
};
